module.exports = __webpack_public_path__ + "fonts/CircularStd-Medium.4fcdd97f.otf";